import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image4 from "../../../../assets/images/Blog32/image4 Fidelity measure of seasonality.png";
import image5 from "../../../../assets/images/Blog32/image5 dramatic US CPI chart (1).jpeg";
import image6 from "../../../../assets/images/Blog32/image6 ISM services correlation worry.png";
import image8 from "../../../../assets/images/Blog32/image8 more China data dumps.jpeg";
import image9 from "../../../../assets/images/Blog32/image9 michigan data confusion (1).png";
import image52 from "../../../../assets/images/Blog32/image52 Fedtool Sep25.png";
import image14 from "../../../../assets/images/Blog32/image14 BoaBull&Bear neutral.png";
import image19 from "../../../../assets/images/Blog32/image19 AAII bearish sentiment creeping back in.png";
import image26 from "../../../../assets/images/Blog32/image26 VIX seasonality ex crashes (1).png";
import image29 from "../../../../assets/images/Blog32/image29 eps Q2 25 spurt.png";
import image30 from "../../../../assets/images/Blog32/image30 2025 eps recovery rarity.png";
import image32 from "../../../../assets/images/Blog32/image32 mag7 for a number of reasons...mainly growth (1).png";
import image47 from "../../../../assets/images/Blog32/image47 gold most bullish (1).png";
import image50 from "../../../../assets/images/Blog32/image50 Oil stuck trending down_ (1).png";
import image17 from "../../../../assets/images/Blog32/image17 Gold Etf flows only just coming in.jpeg";
import image22 from "../../../../assets/images/Blog32/image22 crowded trades.jpeg";
const Blog32 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – August 18th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Jackson Hole, Inflation Whiplash, and Summer Seasonality</p>
        <p>
          Markets enter the week at record highs but on shaky legs, with traders eyeing Jackson Hole for clarity. A 25bp cut in September is now the base case, though whispers of a “buy the rumour,
          sell the fact” fade linger. Meanwhile, geopolitics is back on the radar with Trump-Putin theatrics in Alaska, Ukraine guarantees in play, and oil slipping on renewed Russian flows. Beneath
          the calm, cracks in breadth, sentiment, and services inflation are worth watching.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Highs on Fumes, Cracks Beneath</p>
              <p>The bulls still have control, but the structure looks increasingly fragile:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">SPX</span> at all-time highs, but leadership is narrow—10 stocks driving 80% of gains.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil</span> sold off as peace chatter allows Russian supply back.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold</span> consolidating, but miners see inflows—a bullish tell.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Seasonality </span>into late August and September historically brings weakness, especially in post-election years.
                  </p>
                </li>
              </ul>
              <div className="relatedImg">
                <img
                  src={image4}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image4)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>Summer liquidity is thin, which means volatility can spike without much warning. Think cartoon physics: all looks fine—until everyone looks down.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Powell in the Hole</p>
              <p className="highlightedText">Inflation: The Services Sting</p>
              <p>
                Last week’s US CPI/PPI mix was unsettling. Goods stayed tame, but services inflation roared back, raising stagflation whispers. ISM Services Prices Paid—a 12-month lead on Core CPI—is
                flashing red.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p className="highlightedText">Global Data: Diverging Paths</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan </span>beat GDP expectations, freeing the BoJ to stay hawkish if inflation holds.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK </span>GDP also beat, supporting a slow, steady BoE easing path.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China's </span>retail sales slumped, and PPI deflation deepened. The fiscal “bazooka” can’t be far.
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p className="highlightedText">US Consumers: Strong but Shaky</p>
              <p>Retail sales were broad-based and solid, led by autos and online promos. Yet sentiment fell for the first time since April—and UoM credibility came under fire.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p className="highlightedText">Rates: All Eyes on Jackson Hole</p>
              <p>Fed cut odds remain stacked for September, but hotter PPI trimmed expectations from 100% to 90%. Talk of 50bps lingers, but 25bps is the base case.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image52}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image52)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Fragile Setup</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p className="highlightedText">Sentiment Neutral, But Fragile</p>
                  <p>BofA’s bull-bear index sits neutral, while AAII shows bearishness creeping back in. Not panic levels, but enough to suggest fragility at highs.</p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image14}
                        alt=""
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image14)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image19}
                        alt=""
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image19)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">Volatility Seasonality</p>
                  <p>The VIX tends to rise into late Q3 and Q4—even excluding GFC and Covid extremes. Summer calm rarely lasts.</p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image26}
                        alt=""
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image26)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p className="highlightedText">Earnings: A Rare Q2 Spurt</p>
                  <p>EPS growth in Q2 accelerated unusually fast, forcing underweights to chase. Analysts were caught off guard, turning a would-be earnings drag into a tailwind.</p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image29}
                        alt=""
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image29)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image30}
                        alt=""
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image30)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">Narrow Leadership</p>
                  <p>The MAG7 remains the most crowded trade. Earnings still justify the flows, but watch credit spreads—first cracks will show there.</p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image32}
                        alt=""
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image32)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">Gold vs. Oil Divergence</p>
                  <p>Gold sits in a bullish consolidation triangle, with miners attracting inflows. Oil, meanwhile, drifts lower on Russian supply and inventory builds.</p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image47}
                        alt=""
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image47)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image50}
                        alt=""
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image50)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <p>This is late-cycle behaviour: narrow leadership, defensive flows into metals, and creeping volatility.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Inflation Sparks, Earnings Punch</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Inflation: </span> US CPI showed an uptick led by services; PPI surged on vegetables and services. Tariff effects muted—for now.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Retail Sales:</span> Stronger on autos and online, but services spending sagged.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Global Data: </span> UK GDP stronger than expected, Japan back to growth, while China disappointed across the board.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Fed Speak: </span> Mixed—hawks urging patience, doves open to cuts. 50bps chatter flared, but odds remain stacked for 25bps.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span> Applied Materials disappointed, UnitedHealth surged on fresh inflows.
                  </p>
                </li>
              </ul>
              <p>Markets largely shrugged off the noise, grinding higher on liquidity and buy-the-dip psychology.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Day by Day Breakdown</p>

              <p className="highlightedText">Monday, August 18th</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">NZD: </span>Performance of Services Index 48.9 (up from 47.6)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">GBP:</span> Rightmove HPI YoY -1.3% (vs +0.1% prior); UK home prices are nearly £11k cheaper over 3 months
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">CHF:</span> Industrial Production
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">EZ:</span> Trade Balance
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">CAD:</span> Housing Starts (July)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">USD: </span>NAHB Housing Market Index (Aug)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Auctions: </span> German 12M bill, US 3M & 6M bills
                  </p>
                </li>
              </ul>

              <hr className="divisionLine" />

              <p className="highlightedText">Tuesday, August 19th</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">NZD: </span> PPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">EZ: </span>Current Account
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">USD:</span> Building Permits (July), Housing Starts (July), Redbook, Atlanta GDPNow
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">CAD:</span> CPI (July)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> OIL:</span> API weekly inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Auctions: </span> German 5Y Bobl
                  </p>
                </li>
              </ul>
              <hr className="divisionLine" />

              <p className="highlightedText">Wednesday, August 20th</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">JPY:</span> Machine Orders, Trade Balance
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">CNY: </span>Loan Prime Rate (expected unchanged 3.5% 5Y, 3.0% 1Y)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">NZD:</span> RBNZ Rate Statement (expected 25bp cut to 3%)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">GBP:</span> CPI/RPI (July)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">GR:</span> PPI (July)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">EZ:</span> CPI (July final)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">USD:</span> Mortgage data, FOMC minutes
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">CAD:</span> New HPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Auctions:</span> German 30Y Bund, US 20Y Bond
                  </p>
                </li>
              </ul>
              <hr className="divisionLine" />

              <p className="highlightedText">Thursday, August 21st</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">NZD:</span> Trade Balance
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">AUD:</span> Manufacturing & Services PMI (Aug)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Global:</span> Flash PMIs (EZ, UK, US, Japan, India)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">CHF:</span> Trade Balance
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">USD:</span> Jobless Claims, Philly Fed Index, Existing Home Sales, Fed Balance Sheet
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">CAD:</span> PPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">EZ:</span> Consumer Confidence (Aug)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Auctions:</span> US 4W Bill, 8W Bill, 30Y TIPS
                  </p>
                </li>
              </ul>
              <hr className="divisionLine" />

              <p className="highlightedText">Friday, August 22nd</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">GBP:</span> GfK Consumer Confidence (Aug), Retail Sales
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">JPY:</span> National CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">GER:</span> GDP
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">CAD:</span> Retail Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">USD:</span> Jackson Hole Symposium begins (key risk event)
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image26}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image26)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Buy the Dip or Sell the Fact?</p>
              <p>
                This market is walking on air: record highs, narrow leadership, and seasonal chop ahead. Jackson Hole may be Powell’s chance to thread the needle—but with services inflation back,
                tariffs biting, and political heat rising, the risk is the Fed underdelivers.
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Short-term:</span> Defensive rotation and higher vol likely.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Medium-term:</span> Earnings strength and liquidity still support the bull.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Trade setups:</span>
                  </p>
                  <ul style={{listStyleType: "disc", paddingLeft: "1rem"}}>
                    <li>Buy dips in quality equities</li>
                    <li>Hedge with gold/silver on breakout watch</li>
                    <li>Stay nimble on oil until supply politics clear</li>
                  </ul>
                </li>
              </ul>
              <p>The market isn’t in bubble territory yet, but it is running on fumes. Don’t chase highs—keep cash ready for the dip.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image32}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image32)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image47}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image47)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image50}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image50)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1OyszMpjLvHO-5f8zZF-E-jndvir8CiUmdDmbZ-IFX8g/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog32;
